import cx from 'classnames';
import React, { ElementType, HTMLAttributes } from 'react';
import { ModalBsSize } from '../../modal.types';

export type ModalFooterProps = {
  componentClass?: ElementType;
  bsClass?: string;
  bsSize?: ModalBsSize;
} & HTMLAttributes<HTMLElement>;

export const ModalFooter: React.FC<ModalFooterProps> = ({
  componentClass: Component = 'div',
  className,
  bsClass = 'modal-footer',
  bsSize,
  ...rest
}) => {
  return (
    <Component {...rest} className={cx(bsClass, className)} />
  );
};
